/** デバッグモードかどうか。本番公開時にはfalseにする */
const DEBUG_MODE = true;


/** デバッグモードでConsoleAPIが有効な場合にログを出力する */
export function LogD(s: string, isDisp : boolean) {
    if (DEBUG_MODE && isDisp && console && typeof console.log != "undefined") {
        console.debug(s);
    }
}


export const debug = (content: any): void => {
    console.log('--- DEBUG ---')
    if (Array.isArray(content)) {
        console.log('Array', ':')
        console.table(content)
    } else if (Number.isNaN(content)) {
        console.log('NaN', ':', content)
    } else {
        console.log(Object.prototype.toString.call(content).slice(8, -1), ':', content)
    }
}

export const isNullOrUndefined = (content: any): boolean => {
    return content === null || content === undefined
}
